module.exports = __webpack_public_path__ + "static/media/michael-kiley.62b879dd.md";